import { render } from "./TestEnvironment.vue?vue&type=template&id=286bba14&scoped=true"
import script from "./TestEnvironment.vue?vue&type=script&lang=js"
export * from "./TestEnvironment.vue?vue&type=script&lang=js"

import "./TestEnvironment.vue?vue&type=style&index=0&id=286bba14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286bba14"]])

export default __exports__